module.exports = __webpack_public_path__ + "media/images/gallery/constellations/delphinus/del_names-ace9963e0885d901527a8eba57d1b7c6.gif";